import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ChartModule } from 'primeng/chart';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { AuthGuard } from '@app/core/okta-auth.guard';
import { AdoptionPageComponent } from './adoption-page/adoption-page.component';

const routes: Routes = [
  {
    path: 'adoption',
    canActivate: [AuthGuard],
    component: AdoptionPageComponent,
  },
];

@NgModule({
  declarations: [AdoptionPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChartModule,
    EmeraldDesignSystemModule,
    EmeraldDropdownModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [RouterModule],
})
export class AdoptionModule {}
